import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WarehouseWorkingDay } from './WarehouseWorkingDay'
/**
* Class WarehouseWorkingHours
*  Режим работы точки.
*/
export class WarehouseWorkingHours extends ActiveModel {

/**
  * @property days
  * Ровно семь записей, по одной на день недели, без повторов.  */
  @ActiveField({
    factory: [WarehouseWorkingDay, () => []]
  })
  days: Array<WarehouseWorkingDay> = []


/**
  * note
  * Свободное примечание к режиму работы.
  */
  @ActiveField()
  note?: null | string
}
